import React from 'react';
import { Badge } from '@/components/ui/badge';
import { resolveAccountFit, accountFitLabelKey } from '@/lib/accountFitDisplay';
import { useTranslation } from '@/components/utils/translations';

/** Shared account-fit badge. Null score → "Not scored", never "Low ()". */
export default function AccountFitBadge({ account, className = 'text-xs' }) {
  const { t } = useTranslation();
  const fit = resolveAccountFit(account);
  if (!fit.scored) {
    return (
      <Badge variant="outline" className={`text-muted-foreground ${className}`}>
        {t('homeNotScored')}
      </Badge>
    );
  }
  // Display only: fit.label (English) still drives fit.color.
  const labelKey = accountFitLabelKey(fit.label);
  const displayLabel = labelKey ? t(labelKey) : fit.label;
  return (
    <Badge className={`${fit.color} border ${className}`}>
      {displayLabel} ({fit.score})
    </Badge>
  );
}
